// Rapor türü normalizasyonu (saf) — kapak önerisinin ham etiketi → `ReportType` id.
// Backend (`suggest.ts` → `ImportSuggestion.reportTypeId`) ve frontend (taslak okuma)
// AYNI kuralı kullanır; iki kopya = iki farklı tür tanımı demek olurdu.
import { REPORT_TYPES, type ReportType } from "../schemas/report-type.js";

/** Türkçe harfleri katlayıp küçültür — "SÜRDÜRÜLEBİLİRLİK" ↔ "surdurulebilirlik". */
function fold(raw: string): string {
  return raw
    .replace(/[İIı]/g, "i")
    .replace(/[Şş]/g, "s")
    .replace(/[Ğğ]/g, "g")
    .replace(/[Üü]/g, "u")
    .replace(/[Öö]/g, "o")
    .replace(/[Çç]/g, "c")
    .toLowerCase();
}

/**
 * Serbest metin rapor türü etiketini sabit listedeki id'ye indirir; hiçbir anahtar
 * geçmiyorsa `null` (alan boş kalır, kullanıcı seçer — uydurma tür yazılmaz).
 *
 * Sıra ÖNEMLİ: "entegre" en özgüldür ("2025 Entegre Faaliyet Raporu" içinde "faaliyet"
 * de geçer). "TSRS" `gri`'den ÖNCE bakılır — TSRS raporlarının yaygın kapak başlığı
 * "TSRS Uyumlu Sürdürülebilirlik Raporu"dur ve bu dosya TSRS'tir, GRI değil.
 * "gri" sözcük sınırıyla aranır (aksi halde "entegre"/"agrı" yanlış eşleşirdi).
 */
export function normalizeReportType(raw: string | null | undefined): ReportType | null {
  if (typeof raw !== "string" || raw.trim().length === 0) return null;
  const text = fold(raw);
  if (text.includes("entegre")) return "entegre";
  if (text.includes("tsrs")) return "tsrs";
  if (text.includes("surdurulebilirlik") || /\bgri\b/.test(text)) return "gri";
  if (text.includes("faaliyet")) return "faaliyet";
  return null;
}

/**
 * Bilinmeyen kaynaktan (localStorage taslağı, eski satır) gelen değeri id'ye çevirir:
 * önce id'nin kendisi mi diye bakar, sonra etiket metni gibi normalize eder.
 */
export function coerceReportType(value: unknown): ReportType | null {
  if (typeof value !== "string") return null;
  if ((REPORT_TYPES as readonly string[]).includes(value)) return value as ReportType;
  return normalizeReportType(value);
}
